module.exports = __webpack_public_path__ + "img/home-3.39611968.png";